import Address from "./address";
import {CUSTOM_SCROLL, CUSTOM_SCROLL_LOCK, isDebug, isIe11} from "./globalVars";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import SiteData from '/setting/site-data';

let instance;

export default class Header {
    constructor() {
        if (instance) return instance;
        this.init();
        instance = this;
    }

    init() {
        this.prevScroll = 0;
        this.headerDesktopEl = document.querySelector('header .sec-desktop');
        this.headerTabletEl = document.querySelector('header .sec-tablet');
        this.headerLogoEl = document.getElementById('header-logo');
        this.headerEl = document.querySelector('header');
        this.headerProductNavigationEl = document.querySelector('header .sec-product-navigation');
        // this.headerMyPageNavigationEl = document.querySelector('header .sec-mypage-navigation');
        this.tabletSubEl = document.querySelector('header .sec-tablet-sub');
        this.tabletProductNavigationHolder = document.querySelector('header .sec-product-navigation .component-product-navigation-holder')

        this.isTabletSubShow = false;


        this.desktopMenuEls = document.querySelectorAll('section.sec-desktop a');
        this.addEvent();
    }

    addEvent() {
        window.addEventListener(CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
        window.addEventListener('resize', ()=>this.onResizeHandler());
        document.querySelector('#header-menu').addEventListener('click', ()=>this.setToggleTabletMenu());

        document.querySelector('#header-desktop-product').addEventListener('mouseover', ()=>this.onDesktopProductMenuShowHandler());
        document.querySelector('#header-desktop-product-sub').addEventListener('mouseover', ()=>this.onDesktopProductMenuShowHandler());
        document.querySelector('#header-desktop-prestige').addEventListener('mouseover', ()=>this.onDesktopProductMenuHideHandler());

        document.querySelector('#header-desktop-product-sub').addEventListener('mouseout', ()=>this.onDesktopProductMenuHideHandler());
        document.querySelector('#header-desktop-product-sub').addEventListener('mouseleave', ()=>this.onDesktopProductMenuHideHandler());

        this.mobileMenuEls = document.querySelectorAll('section.sec-tablet-sub a');
        this.mobileMenuEls.forEach((el) => {
            if (el.getAttribute('href') === '#') {
                el.addEventListener('click', (e)=>this.onMobileMenuClickHandler(e));
            }
        });

        document.querySelectorAll('header .sec-tablet-sub .component-product-navigation-holder a').forEach((el) => {
            el.addEventListener('click', (e)=>this.onMobileProductSubMenuClickHandler(e));
        });

        document.querySelectorAll('.section-title .component-product-navigation-holder a').forEach((el) => {
            el.addEventListener('click', (e)=>this.onMobileProductSubMenuClickHandler(e));
        });

        document.querySelectorAll('header .sec-product-navigation .component-product-navigation-holder a').forEach((el) => {
            el.addEventListener('click', (e) => this.onMobileProductSubMenuClickHandler(e));
        });
    }

    setScrollDefault() {
        this.prevScroll = 0;
        this.headerEl.style.transform = 'translate3D(0, 0, 0)';
    }

    onScrollHandler(e) {
        if (this.isTabletSubShow) return;


        if ((this.prevScroll > e.detail) || (e.detail <= 0 ))  {
            this.headerEl.style.transform = 'translate3D(0, 0, 0)';
        } else {
            let height = parseFloat(window.getComputedStyle(this.headerTabletEl).height) * -1;
            this.headerEl.style.transform = `translate3D(0, ${height}px , 0)`;
        }
        this.prevScroll = e.detail;
    }

    onResizeHandler() {
        this.setHideTabletMenu();
    }

    onDesktopProductMenuShowHandler() {
        //product list 페이지 일 경우 서브 메뉴 표시 하지 않음.
        if (new Address().getCurrentNameSpace() === 'product-list') return;

        document.querySelector('#header-desktop-product a').classList.add('focus');
        let el = document.querySelector('#header-desktop-product-sub');
        el.classList.add('onShow');
    }

    onDesktopProductMenuHideHandler() {
        document.querySelector('#header-desktop-product a').classList.remove('focus');
        let el = document.querySelector('#header-desktop-product-sub');
        el.classList.remove('onShow');
    }

    setSubNavigation(namespace, classList) {
        if (!isIe11()) {
            this.tabletProductNavigationHolder.scrollTo(0, 0);
        }
        if (namespace === 'technology' || namespace === 'prestige' || classList.contains('prestige-detail')) {

            if (isIe11()) {
                document.querySelector('header .background').style.background = '#000';
            }

            document.querySelector('html').style.background = '#000 !important';
            document.querySelector('body').style.background = '#000 !important';
            document.querySelector('header').classList.add('white');
            if (document.querySelectorAll('footer')) {
                document.querySelectorAll('footer').forEach((el) => {
                    el.classList.add('white');
                })
            }
        } else {
            if (isIe11()) {
                document.querySelector('header .background').style.background = '#fff';
            }

            document.querySelector('html').style.background = '#fff !important';
            document.querySelector('body').style.background = '#fff !important';
            document.querySelector('header').classList.remove('white');

            if (document.querySelectorAll('footer')) {
                document.querySelectorAll('footer').forEach((el) => {
                    el.classList.remove('white');
                })
            }
        }
        this.headerProductNavigationEl.classList.remove('onShow');
        // this.headerMyPageNavigationEl.classList.remove('onShow');

        this.setFocus(namespace);

        switch(namespace) {
            case 'product-list':
                this.headerProductNavigationEl.classList.add('onShow');
                break;
            // case 'mypage-point':
            //     this.headerMyPageNavigationEl.classList.add('onShow');
            //     break;
            // case 'mypage-modify':
            //     this.headerMyPageNavigationEl.classList.add('onShow');
            //     break;
            // case 'mypage-membership':
            //     this.headerMyPageNavigationEl.classList.add('onShow');
            //     break;
        }
    }

    setFocus(namespace) {
        this.setMobileMenuFocus(undefined);
        let tmpNameSpace;
        let categoryNamespace;

        if (namespace === 'oera-story' || namespace === 'technology' || namespace === 'calibration-ritual') {
            categoryNamespace = 'philosophy';
        }

        if (namespace === 'product-list' || namespace === 'product-detail') {
            categoryNamespace = 'product-list';
        }


        this.mobileMenuEls.forEach((el) => {
            tmpNameSpace = el.getAttribute('data-namespace');
            if (tmpNameSpace === namespace) {
                el.classList.add('onFocus');
            }
            if (tmpNameSpace === categoryNamespace) {
                this.setMobileMenuFocusEl(el,true);
            }
        })

        this.desktopMenuEls.forEach((el) => {
            el.classList.remove('onFocus');
            tmpNameSpace = el.getAttribute('data-namespace');

            // console.log(tmpNameSpace);
            if (tmpNameSpace === namespace) {
                el.classList.add('onFocus');
            }

            if (tmpNameSpace === categoryNamespace) {
                el.classList.add('onFocus');
            }
        })
    }

    setToggleTabletMenu() {
        if(this.isTabletSubShow) {
            this.setHideTabletMenu();
        } else {
            this.setShowTabletMenu();
        }
    }

    setShowTabletMenu() {
        this.isTabletSubShow = true;
        this.tabletSubEl.classList.add('onShow');
        this.headerEl.classList.add('onShow');

        this.setFocus(new Address().currentNameSpace);

        let evt =new CustomEvent(CUSTOM_SCROLL_LOCK, {detail:true});
        window.dispatchEvent(evt);
    }

    setHideTabletMenu() {
        this.isTabletSubShow = false;
        this.tabletSubEl.classList.remove('onShow');
        this.headerEl.classList.remove('onShow');

        let evt =new CustomEvent(CUSTOM_SCROLL_LOCK, {detail:false});
        window.dispatchEvent(evt);
    }

    setLogin() {
        document.querySelector('header').style.display = 'block';
        if (isDebug) console.log('- 3.1 > set login');
        document.querySelectorAll('header .is-login').forEach((el)=>{
            el.style.display = 'block';
        });
        document.querySelectorAll('header .is-logout').forEach((el)=>{
            el.style.display = 'none';
        })
    }

    setLogout() {
        document.querySelector('header').style.display = 'block';
        if (isDebug) console.log('- 3.1 > set logout');
        document.querySelectorAll('header .is-login').forEach((el)=>{
            el.style.display = 'none';
        });
        document.querySelectorAll('header .is-logout').forEach((el)=>{
            el.style.display = 'block';
        })
    }

    onMobileMenuClickHandler(e) {
        e.preventDefault();
        this.setMobileMenuFocus(e.target);
    }

    setMobileMenuFocus(currentEl) {
        this.mobileMenuEls.forEach((el) => {
            if (el.parentNode.parentNode.parentNode) {
                if (el.parentNode.parentNode.parentNode.classList.contains('component-product-navigation-holder')) {
                    return;
                }
            }

            if (el === currentEl) {
                if (el.classList.contains('onFocus')) {
                    this.setMobileMenuFocusEl(el, false);
                } else {
                    this.setMobileMenuFocusEl(el, true);
                }
            } else {
                this.setMobileMenuFocusEl(el, false);
            }

        })
    }

    setMobileMenuFocusEl(el, isFocus) {
        let subEl = el.parentNode.querySelector('.inner-sub');

        if (isFocus) {
            el.classList.add('onFocus');
            if (subEl) subEl.classList.add('onShow');
        } else {
            el.classList.remove('onFocus');
            if (subEl) subEl.classList.remove('onShow');
        }
    }

    setProductFocus(num) {
        // console.log('----> tablet show ' + num + ' / ' +  this.isTabletSubShow);
        if (this.isTabletSubShow) return;

        // window.scrollHashChange = true;
        // let url = String(window.location).split('#')[0] + '#' + SiteData.productCategory[num].hash;
        // history.replaceState({}, '',url);

        this.setProductFocusEl(
            document.querySelectorAll('.section-title .component-product-navigation-holder a'),
            num
        )

        this.setProductFocusEl(
            document.querySelectorAll('header .sec-tablet-sub .component-product-navigation-holder a'),
            num
        )

        let scrollX =
        this.setProductFocusEl(
            document.querySelectorAll('header .sec-product-navigation .component-product-navigation-holder a'),
            num
        );
        if (!isIe11()) {
            this.tabletProductNavigationHolder.scrollTo(scrollX.parentNode.parentNode.offsetLeft - scrollX.parentNode.parentNode.offsetWidth / 2, 0);
        }
        // console.log(document.querySelectorAll('header .sec-tablet-sub  .component-product-navigation-holder a'));
    }

    setProductFocusEl(els, num) {
        let idx = 0;
        let returnValue = 0;
        els.forEach((el)=> {
            el.classList.remove('onFocus');
            if (idx === num) {
                returnValue = el;
                el.classList.add('onFocus');
            }
            idx ++;
        })

        return returnValue;
    }

    onMobileProductSubMenuClickHandler(e) {
        if (new Address().currentNameSpace === 'product-list') {
            let id = String(e.currentTarget.getAttribute('href')).split('#')[1];
            if (id === String(window.location.hash).split('#')[1]) {
                new Address().scrollControl.scrollSave = this.getProductSectionY(id);
            }
            this.setHideTabletMenu();
            return false;
        }
        return true;
    }

    getProductSectionY(id) {
        let idx = 0;
        let currentIdx;

        SiteData.productCategory.forEach((data)=>{
            if (data.hash === id) {
                currentIdx = idx;
            }
            idx ++;
        })

        return window.productListSubY[currentIdx];
    }
}
